// Memoization caches for expensive color calculations
const textColorCache = new Map<string, string>();
const rgbaCache = new Map<string, string>();

export const getAccessibleTextColor = (backgroundColorHex: string): string => {
  // Check cache first
  if (textColorCache.has(backgroundColorHex)) {
    return textColorCache.get(backgroundColorHex)!;
  }

  const threshold = 148;
  const hRed = hexToR(backgroundColorHex);
  const hGreen = hexToG(backgroundColorHex);
  const hBlue = hexToB(backgroundColorHex);

  const colorBrightness = (hRed * 299 + hGreen * 587 + hBlue * 114) / 1000;

  const result = colorBrightness < threshold ? "#FFFFFF" : "#000000";

  // Cache the result
  textColorCache.set(backgroundColorHex, result);

  return result;
};

export const hex2rgba = (color: string, alpha: number): string => {
  // Create cache key from color and alpha
  const cacheKey = `${color}-${alpha}`;

  // Check cache first
  if (rgbaCache.has(cacheKey)) {
    return rgbaCache.get(cacheKey)!;
  }

  const hRed = hexToR(color);
  const hGreen = hexToG(color);
  const hBlue = hexToB(color);

  const result = `rgba(${hRed}, ${hGreen}, ${hBlue}, ${alpha})`;

  // Cache the result
  rgbaCache.set(cacheKey, result);

  return result;
};

// Opaque, so overlapping fills cover each other instead of compounding alpha.
export const tintOnWhite = (color: string, percent: number): string =>
  `color-mix(in srgb, ${color} ${percent}%, white)`;

export const primaryColor = "#38B2AC";
export const secondaryColor = "#2D3748";

const cutHex = (hex: string) => {
  return hex.charAt(0) === "#" ? hex.substring(1, 7) : hex;
};
const hexToR = (hex: string): number => {
  return parseInt(cutHex(hex).substring(0, 2), 16);
};

const hexToG = (hex: string): number => {
  return parseInt(cutHex(hex).substring(2, 4), 16);
};

const hexToB = (hex: string): number => {
  return parseInt(cutHex(hex).substring(4, 6), 16);
};
